// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f06b6e07","667":"feff6ade"}[chunkId] + ".chunk.js";
};